"use strict";
/*
 * Created on 02 20 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * Serialization/deserialization converter of {@link SelloutSupply}.
 *
 * @author JMe
 */


var SelloutSupplyConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SelloutSupplyConverter, _DataObjectConverter_);

  function SelloutSupplyConverter() {
    _classCallCheck(this, SelloutSupplyConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutSupplyConverter).apply(this, arguments));
  }

  return SelloutSupplyConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SelloutSupplyConverter = SelloutSupplyConverter;